export default __webpack_public_path__ + "static/media/gallery-wip-pre-paint_05.1691ae30.jpg";